import React, { useState, forwardRef, useImperativeHandle } from 'react';
import HolidayCalendarModal from './HolidayCalendarModal';
import HolidayTable from './HolidayTable';

const HolidayExclusionSection = forwardRef(
({ holidays = [], onChange, disabled = false }, ref) => {

    const [showCalendarModal, setShowCalendarModal] = useState(false);
    const [holidayErrors, setHolidayErrors] = useState({});

    const handleAddHolidays = (newHolidays) => {
        const updatedHolidays = [...holidays, ...newHolidays];
        onChange(updatedHolidays);
        setShowCalendarModal(false);
    };

    const handleDeleteHoliday = (index) => {
        const updatedHolidays = holidays.filter((_, idx) => idx !== index);
        onChange(updatedHolidays);

        const newErrors = {};
        Object.keys(holidayErrors).forEach(key => {
            const errorIndex = parseInt(key);
            if (errorIndex < index) {
                newErrors[errorIndex] = holidayErrors[key];
            } else if (errorIndex > index) {
                newErrors[errorIndex - 1] = holidayErrors[key];
            }
        });
        setHolidayErrors(newErrors);
    };

    const handleUpdateHolidayName = (index, value) => {
        const updatedHolidays = [...holidays];
        updatedHolidays[index] = {
            ...updatedHolidays[index],
            holiday_name: value
        };
        onChange(updatedHolidays);

        if (value.trim()) {
            const newErrors = { ...holidayErrors };
            delete newErrors[index];
            setHolidayErrors(newErrors);
        }
    };

    const validateHolidays = () => {
        const errors = {};
        holidays.forEach((holiday, index) => {
            if (!holiday.holiday_name || !holiday.holiday_name.trim()) {
                errors[index] = 'Holiday name is required';
            }
        });
        setHolidayErrors(errors);
        return Object.keys(errors).length === 0;
    };

    //  Correct usage
    useImperativeHandle(ref, () => ({
        validate: validateHolidays
    }));

    return (
        <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-md-12">
                <div className="form-group" style={{ marginBottom: 10 }}>
                    <label className="pd10botbuilder">
                        Set Holiday Rule to Exclude Days from Campaign
                    </label>

                    <button
                        type="button"
                        className="btn add-link"
                        onClick={() => setShowCalendarModal(true)}
                        disabled={disabled}
                        style={{
                            fontSize: '14px',
                            marginBottom: '10px',
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            opacity: disabled ? 0.6 : 1
                        }}
                    >
                        <i className="la la-plus mr-1"></i>
                        Add Holiday Dates
                    </button>

                    <HolidayTable
                        holidays={holidays}
                        onDeleteHoliday={handleDeleteHoliday}
                        onUpdateHolidayName={handleUpdateHolidayName}
                        errors={holidayErrors}
                    />
                </div>
            </div>

            <HolidayCalendarModal
                show={showCalendarModal}
                onClose={() => setShowCalendarModal(false)}
                onDone={handleAddHolidays}
                existingHolidays={holidays}
            />
        </div>
    );
});

export default HolidayExclusionSection;